module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "service"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("\n        供应链金融服务\n        "), _c('span', [_vm._v("成本和收益\n          "), _c('div', {
    staticClass: "dialog"
  }, [_c('h3', [_vm._v("核心无需实际承担财务费用，由现金折扣获得的收益来覆盖")]), _vm._v(" "), _c('p', [_vm._v("资金方和平台是需要收取利息手续费的。那这部分钱谁出呢？以现金采购方案为例，供应商在选择提早拿到货款时可以给核心企业打个折扣。利息和手续费可以根据实际情况，由核心和供应商进行商谈。")]), _vm._v(" "), _c('h4', [_vm._v("举个例子：")]), _vm._v(" "), _c('h5', [_c('i', [_vm._v("假设供应商愿意给到的折扣是95折。")]), _c('br'), _c('i', [_vm._v("即100块钱的货款，供应商支付给核心5元的成本，换取3个月的账期。")]), _c('br'), _c('i', [_vm._v("而核心企业的需要支付给资金方和平台的费率是年化10%。")]), _c('br'), _c('i', [_vm._v("核心成本：95*10%/12*3=2.375元。")]), _c('br'), _c('i', [_vm._v("所以说在支付完资金方和平台费用之后，核心还有收益2.625元。")])]), _vm._v(" "), _c('p', [_vm._v("综上，在现金采购方案中核心"), _c('strong', [_vm._v("无需承担任何实际成本")]), _vm._v("。同时供应商也满足了自己的诉求。")])])])]), _vm._v(" "), _c('h2', [_vm._v("每个企业及其供应商都是独一无二的。因此，您的供应链金融方案的要求和计划执行也将是独一无二的。"), _c('br'), _vm._v("群星会提供灵活，可扩展的解决方案，"), _c('br'), _vm._v("根据您的营运资金目标量身定制，同时支持上下游供应商／经销商的应收账款转让服务。")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/zijin_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("资金方案"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("资金方案服务"), _c('span', [_vm._v("群星利用自身的资源和专业化能力，依据核心企业的需求、市场状况，设计产业链融资方案，并结合上述大数据分析筛选的结果，为核心企业在市场上寻找匹配的资金合作渠道，确定与资金合作渠道的合作流程、价格、设计方案。")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/data_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("数据分析"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("数据分析服务"), _c('span', [_vm._v("群星金融运用大数据分析系统、机器学习、人工智能等新技术，对核心企业提供的应付账款进行准确分类、应用量化模型，筛选出可提供融资服务的上游企业准入清单，测算出相关的风险控制参数（如授信额度等）")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/lianshu_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("链属营销"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("链属营销服务"), _c('span', [_vm._v("依托互联网营销平台和社会化营销工具，群星金融提供快速高效的产业链融资信息传播、客户营销服务，从而给核心企业创造最大的价值。")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/line_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("线上平台"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("线上平台服务"), _c('span', [_vm._v("群星依托其自动化运营系统为用户提供全程电子化、自动化运营操作功能（包括认证、签约、融资申请、融资发放、还款核销、资金监管等），以帮助核心企业及其上游供应商快速便捷地从资金方获得融资服务。")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星金融白皮书"), _c('span', [_vm._v("无论您的公司是供应链金融新手还是熟悉流程，我们的白皮书都可以为您提供更多信息，帮助您提高供应链金融方案的成功率。")])]), _vm._v(" "), _c('a', {
    staticClass: "file",
    attrs: {
      "href": "/pdf/portal/群星金融产品白皮书.zip"
    }
  }, [_c('span', [_vm._v("下载白皮书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/download@2x.png",
      "alt": "icon"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2a58c9d4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/products/Service.vue
// module id = 1287
// module chunks = 26